import styled from 'styled-components';

const ListContainer = styled.article``;

export default ListContainer;
